module.exports = __webpack_public_path__ + "static/media/protagonists.38c56b58.svg";